<div
	fxFlex="100%"
	fxLayout="row wrap"
	fxLayoutAlign="start center"
	fxLayoutAlign.lt-sm="start"
	class="social-share"
	*ngIf="!this.isDonationModule; else donationTemplate"
	fxLayoutGap.lg="10px"
	fxLayoutGap.md="20px"
	fxLayoutGap.sm="30px"
	fxLayoutGap.lt-sm="22px"
	fxFlex.lt-sm="100%"
>
	<!-- fxLayoutAlign.lt-sm="center center" -->
	<!-- fxLayoutGap.lt-sm="35px" -->
	<div class="facebook" ngClass="m-t-xs">
		<button
			id="facebookShareButton"
			mat-button
			shareButton="facebook"
			[disabled]="disableSocialShare"
			[url]="this.sharedLink"
		>
			<img
				height="51"
				width="51"
				[src]="
					disableSocialShare
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fb-disabled/public'
						: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fb-color/public'
				"
			/>
		</button>
	</div>
	<div class="email" ngClass="m-t-s">
		<button
			id="emailShareButton"
			mat-button
			shareButton="email"
			[disabled]="disableSocialShare"
			[url]="this.sharedLink"
		>
			<img
				height="50"
				width="57"
				[src]="
					disableSocialShare
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/mail-disabled/public'
						: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/mail-color/public'
				"
			/>
		</button>
	</div>
	<div class="twitter p-t-xs">
		<button
			id="twitterShareButton"
			mat-button
			shareButton="twitter"
			[disabled]="disableSocialShare"
			[url]="this.sharedLink"
		>
			<img
				height="55"
				width="57"
				[src]="
					disableSocialShare
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/x-disabled/public'
						: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/x/public'
				"
			/>
		</button>
	</div>
	<div class="linkedin" ngClass.lt-sm="m-t-xs">
		<button
			id="linkedShareButton"
			mat-button
			shareButton="linkedin"
			[disabled]="disableSocialShare"
			[url]="this.sharedLink"
		>
			<img
				height="54"
				width="57"
				[src]="
					disableSocialShare
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/linkedin-disabled/public'
						: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/linkedin-color/public'
				"
			/>
		</button>
	</div>
	<div class="whatsapp" ngClass.lt-sm="m-t-xs">
		<button
			id="whatsAppShareButton"
			mat-button
			shareButton="whatsapp"
			[disabled]="disableSocialShare"
			[url]="this.sharedLink"
		>
			<img
				height="54"
				width="54"
				[src]="
					disableSocialShare
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whatsapp-disabled/public'
						: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whatsapp-color/public'
				"
			/>
		</button>
	</div>

	<div
		class="social-share"
		ngClass.lt-sm="m-b-xxs m-t-xs"
		ngClass.gt-lg="p-b-l m-b-xxs"
		ngClass.lg="m-b-l"
		ngClass.md="m-b-l"
		ngClass.sm="m-b-l"
	>
		<button
			id="QRCodeButton"
			mat-button
			[disabled]="disableSocialShare"
			(click)="openQrDialog()"
		>
			<img
				height="58"
				width="58"
				[src]="
					disableSocialShare
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/qr2-disabled/public'
						: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/qr2/public'
				"
			/>
		</button>
	</div>
	<div
		*ngIf="componentCalled != 'paymentRequest'"
		class="embeded"
		ngClass.sm="m-b-xxs"
		ngClass.md="m-b-xxs"
		ngClass.lt-sm="m-b-xs m-t-xs"
		(click)="(tabRoute)"
		#tabRoute
	>
		<button
			id="onOwnWebsiteButton"
			mat-button
			[disabled]="disableSocialShare"
			(click)="onTabChange()"
		>
			<img
				height="55"
				width="55"
				[src]="
					disableSocialShare
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/code-disabled/public'
						: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/code/public'
				"
			/>
		</button>
	</div>
	<!-- <div fxLayout="row" fxFlex="100%" fxLayoutAlign="start start">
	</div> -->
</div>

<!--TEMPLATE FOR SHARE CONTRIBUTION COMPONENT FOR DONATION MODULE------------------------------------------------------>
<ng-template #donationTemplate>
	<div
		fxFlex="100%"
		fxLayout="row wrap"
		fxLayoutAlign="start center"
		class="social-share"
		fxLayoutGap.lg="18px"
		fxLayoutGap.lt-sm="0px"
	>
		<button
			[ngStyle]="{ color: '#4267B2' }"
			mat-button
			class="facebook"
			[disabled]="disableSocialShare"
			(click)="shareToFacebook()"
		>
			<div fxLayout="column" fxLayoutAlign="center center">
				<img
					height="28"
					width="28"
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fb-color/public"
				/>
				<span *ngIf="showLabels" class="dark-grey-texts">Facebook</span>
			</div>
		</button>

		<button
			[ngStyle]="{ color: '#25D366' }"
			mat-button
			shareButton="email"
			[disabled]="disableSocialShare"
			[url]="this.customURL"
			[title]="this.currentFundraiserData?.title"
			[description]="this.currentFundraiserData?.description"
			[image]="this.currentFundraiserData?.image"
		>
			<div fxLayout="column" fxLayoutAlign="center center">
				<img
					height="28"
					width="28"
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/mail-color/public"
				/>
				<span *ngIf="showLabels" class="dark-grey-texts">Email</span>
			</div>
		</button>

		<button
			[ngStyle]="{ color: '#00acee' }"
			mat-button
			shareButton="twitter"
			[disabled]="disableSocialShare"
			[url]="this.customURL"
			[title]="this.currentFundraiserData?.title"
			[description]="this.currentFundraiserData?.description"
			[image]="this.currentFundraiserData?.image"
		>
			<div fxLayout="column" fxLayoutAlign="center center">
				<img
					height="28"
					width="28"
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/x/public"
				/>
				<span *ngIf="showLabels" class="dark-grey-texts">X</span>
			</div>
		</button>

		<button
			[ngStyle]="{ color: '#0077b5' }"
			mat-button
			shareButton="linkedin"
			[disabled]="disableSocialShare"
			[url]="this.customURL"
			[title]="this.currentFundraiserData?.title"
			[description]="this.currentFundraiserData?.description"
			[image]="this.currentFundraiserData?.image"
		>
			<div fxLayout="column" fxLayoutAlign="center center">
				<img
					height="28"
					width="28"
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/linkedin-color/public"
				/>
				<span *ngIf="showLabels" class="dark-grey-texts">LinkedIn</span>
			</div>
		</button>

		<button
			class="whatsapp"
			mat-button
			[ngStyle]="{ color: '#25D366' }"
			shareButton="whatsapp"
			[disabled]="disableSocialShare"
			[url]="this.customURL"
			[title]="this.currentFundraiserData?.title"
			[description]="this.currentFundraiserData?.description"
			[image]="this.currentFundraiserData?.image"
		>
			<div fxLayout="column" fxLayoutAlign="center center">
				<img
					height="28"
					width="28"
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whatsapp-color/public"
				/>
				<span *ngIf="showLabels" class="dark-grey-texts">WhatsApp</span>
			</div>
		</button>
	</div>
</ng-template>
